import { render, staticRenderFns } from "./itProofSubmissionApproval.vue?vue&type=template&id=13b1b1b8&scoped=true"
import script from "./itProofSubmissionApproval.vue?vue&type=script&lang=js"
export * from "./itProofSubmissionApproval.vue?vue&type=script&lang=js"
import style0 from "./itProofSubmissionApproval.vue?vue&type=style&index=0&id=13b1b1b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b1b1b8",
  null
  
)

export default component.exports